import React from "react";
import styled from "styled-components";
import { breakpoints, imgix } from "../styles/variables";
import BackgroundWrapper from "./BackgroundWrapper";

import ImgixImg from "./helpers/ImgixImg";

const ImageGrid = styled.div`
  width: 100vw;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;

  > div {
    width: 100%;
    height: 100%;

    img {
      width: 100%;
      height: 100%;
      max-height: 405px;
      display: block;
      object-fit: cover;
    }
  }

  @media screen AND (min-width: ${breakpoints.desktop}px) {
    max-width: 1920px;
    margin: 0 auto;
  }
`;

interface FWThreeImages {
  images: [
    {
      url: string;
    }
  ];
}

const FWThreeImages: React.FC<FWThreeImages> = ({ images }) => (
  <BackgroundWrapper standardMargin>
    <ImageGrid>
      {images.map((item, index) => (
        <div key={index}>
          <ImgixImg src={item.url} imgixParams={imgix.thirdImage} />
        </div>
      ))}
    </ImageGrid>
  </BackgroundWrapper>
);

export default FWThreeImages;
